import React from "react";
import { Link } from "react-router-dom";
import MainLayout from "./Layout/MainLayout";
import styled from "styled-components";
import ImgBlog from "../Assets/Images/Blog_Images.png";
import BlogComment from "../Components/Blog/BlogComment";
import { IconLike } from "../Assets/Icons/IconLike";
import { IconBookMark } from "../Assets/Icons/IconBookMark";
import { IconClander } from "../Assets/Icons/IconClander";
import { IconProfileBlog } from "../Assets/Icons/IconProfileBlog";
import { IconTime } from "../Assets/Icons/IconTime";
import BlogTitrComponentt from "../Components/Blog/Blog_Titr_Component";
import { IconComment } from "../Assets/Icons/IconComment";
import BlogTags from "../Components/Blog/Blog_Tags";
import BlogInputComment from "../Components/Blog/Blog_Input_Comment";
// import BlogComponents from "../Components/Blog/BlogComponent";
import { IconTwitter } from "../Assets/Icons/IconTwitter";
import { IconInstagram } from "../Assets/Icons/IconInstagram";
import { IconLinkdin } from "../Assets/Icons/IconLinkdin";
import Blogs from "../Components/Blog/Blogs";
import BlogComponents from "../Components/Blog/BlogComponent";
const Styles = styled.div`
  display: grid;
  grid-template-columns:
    6.09% repeat(12, calc(calc(84.7% / 12) - calc(17.16% / 12)))
    6.09%;
  grid-column-gap: 1.56%;
  align-items: center;
  justify-content: center;
  .container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    grid-column: 2/10;
    margin-top: 10rem;
  }
  .sidebar {
    height: calc(100% + 4500px) !important;
    background: #201f1e;
    grid-column: 11/14;
    z-index: -10 !important;
  }
  .top-header-container-blog {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
  }
  .bottom-header-container-blog {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    font-style: normal;
    font-weight: 400;
    font-size: var(--fs--18-18-14);
    line-height: 28px;
    color: #c9cbca;
    margin-bottom: 32px;
    margin-top: 16px;
    svg {
      width: 24px !important;
    }
  }
  .r-element-blog {
    display: flex;
  }
  .titlebookmark {
    
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #e5e7eb;
  }
  .titr-blog {
    font-style: normal;
    font-weight: 700;
    font-size: var(--fs--32-28-24) !important;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #ffffff;
  }

  .icon {
    justify-content: flex-end;
    align-items: center;
    display: flex;
    svg {
      margin: 0 0.5rem;
      width: var(--ws--32-28-24);
    }
  }
  .nav-footer-blogstitr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
  }
  .name {
    display: flex;
    align-items: center;
    svg {
      width: 30px;
    }
  }
  .calender {
    display: flex;
    align-items: center;
    svg {
      width: 20px;
    }
  }
  .time {
    display: flex;
    align-items: center;
    svg {
      width: 20px;
    }
  }
  .icon-details {
    margin: 0 0.5rem;
  }
  .footer-icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    a {
      text-decoration: none;
      font-family: "KalamehWebFaNum(FaNum)";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: right;
      color: #ffffff;
      margin: 0 44px;
    }
    svg {
      margin: 0 4px;
      width: var(--fs--32-24-22);
    }
  }
  .footer-icon-sochial {
    
    font-style: normal;
    font-weight: 400;
    font-size: var(--fs--20-14-14);
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #e5e7eb;
  }
  .icon-sochial-blogs {
    display: flex;
    margin-right: 10px;
  }
  .icon-sochial-blogs svg {
    width: var(--fs--32-24-22);
  }
  .left-e {
    display: flex;
  }
  .source {
    
    font-style: normal;
    font-weight: 500;
    font-size: var(--fs--20-14-14);
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #e5e7eb;
  }
  .line {
    border: 2px solid #9ba4ab;
    height: 25px;
    margin: 0 16px;
  }
  .comments-title-blog {
    
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #e5e7eb;
    margin-bottom: 40px;
  }
  .comments {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 120px;
  }
  .footer-content-blogs {
    display: flex;
    flex-direction: row !important;
    margin-bottom: 80px;
    justify-content: space-between;
    grid-column: 2/10;
  }
  .responsive-component-cms {
    grid-column: 2/10;
    margin: 0 auto;
  }
  @media screen and (max-width: 1000px) {
    .icon svg {
      margin: 0 2px;
      width: var(--ws--32-28-24);
    }
    .line {
      border: 1px solid #9ba4ab;
      height: 20px;
      margin-left: 8px;
    }
    .titlebookmark {
      display: none;
    }
    .bottom-header-container-blog {
      display: flex;
      flex-direction: column !important;
      align-items: center;
      justify-content: flex-start;
      font-size: var(--fs--18-18-14);
      margin-bottom: 0 !important;
      margin-top: 10px !important;
    }
    .time {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
    }
    .r-element-blog {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    .nav-footer-blogstitr {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 32px;
    }
    .source {
      display: flex;
      width: 100%;
      margin-bottom: 10px;
    }
    .footer-icon {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-left: 20px;
      a {
        margin-right: 15px !important;
        margin-left: 0 !important;
      }
    }
    .icon-sochial-blogs {
      margin-right: 4px;
      svg {
        margin-left: 12px !important;
      }
    }
    .left-e {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .responsive-component-cms {
      grid-column: 1/15;
      width: calc(100% - 60px) !important;
      margin: 0 auto;
    }
    .sidebar {
      height: 100% !important;
      background: #201f1e;
      grid-column: 11/14;
    }
  }
  @media screen and (max-width: 600px) {
    background: #252526;
    width: calc(100% - 60px) !important;
    display: flex;
    margin: 0 auto;
    flex-direction: column;
    .container {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 60px;
      box-shadow: none;
      margin-bottom: 0 !important;
    }
    .content {
      width: 100%;
    }
    .header-container {
      width: 100%;
    }
    .title-blog-det {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 2rem;
      p {
        color: #ffffff !important;
        
        font-size: 24px;
        font-weight: 500;
        line-height: 23px;
        letter-spacing: 0em;
        text-align: right;
      }
    }
    .icon {
      justify-content: center;
      align-items: center;
      display: flex;
      svg {
        margin: 0;
        width: 24px;
        stroke: white;
      }
    }
    .details {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      color: #c9cbca;
      margin: 0.5rem 0;
      .header-detail {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 10px;
      }
      .footer-detail {
        width: 100%;
        align-items: center;
        justify-content: flex-start;
        display: flex;
        .icon-details {
          margin: 0 4px;
          width: 20px !important;
        }
      }
    }
    .name {
      display: flex;
      align-items: center;
      svg {
        width: 30px;
      }
    }
    .calender {
      display: flex;
      align-items: center;
      svg {
        width: 20px;
      }
    }
    .time {
      display: flex;
      align-items: center;
      svg {
        width: 20px;
      }
    }
    .address {
      color: #6b7074;
      margin: 9px 0 24px;
    }

    .footer-icon {
      display: flex !important;
      justify-content: space-between !important;
      align-items: center;
      width: 100% !important;
      svg {
        width: 24px !important;
        margin: 0 4px !important;
      }
    }
    .line {
      border: 2px solid #9ba4ab;
      height: 25px;
      margin: 0 16px;
    }
    .source {
      margin: 16px 0 40px;
      
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      text-align: right;
      color: #e5e7eb;
    }
    .icon-cm-like {
      display: flex;
      width: 40%;
      a {
        width: 50%;
        display: flex;
        text-decoration: none;
        justify-content: flex-start;
        color: #ffffff;
        align-items: center;
        margin: 0 !important;
        svg {
          width: 24px;
        }
      }
    }
    .sochial-in-blog {
      width: auto;
      display: flex;
      p {
        font-style: normal;
        font-weight: 400;
        font-size: 14px !important;
        line-height: 20px;
        display: flex;
        align-items: center;
        display: flex;
        justify-content: flex-end;
        text-align: right;
        color: #e5e7eb;
      }
      svg {
        width: 24px;
      }
    }
    .comments {
      margin-bottom: 0;
      .titelcomments {
        margin-bottom: 24px;
        
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        display: flex;
        align-items: center;
        text-align: right;
        color: #e5e7eb;
      }
    }
    .footer-content-blogs {
      display: flex;
      margin: 0 !important;
      justify-content: center;
      grid-column: 2/12;
      margin-bottom: 64px;
      img {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 360px) {
    .icon-cm-like {
      width: 40% !important;
      a {
        svg {
          width: 20px !important;
        }
      }
    }
    .sochial-in-blog {
      p {
        font-size: 12px !important;
      }
      svg {
        width: 20px !important;
      }
    }
  }
`;
export const BlogDetails = ({ props }) => {
  if (window.innerWidth > 600) {
    return (
      <MainLayout {...props}>
        <Styles>
          <div className="container">
            <header className="header-container">
              <div className="top-header-container-blog">
                <p className="titr-blog"> عنوان مطلب </p>
                <div className="icon">
                  <p className="titlebookmark"> افزودن به لیست علاقه مندی ها</p>
                  <IconBookMark style={{ marginLeft: "8px" }} />
                  <div className="line" />

                  <IconLike />
                </div>
              </div>
              <div className="border-x" />
              <div className="bottom-header-container-blog">
                <div className="r-element-blog">
                  <div className="name">
                    <IconProfileBlog className={"icon-details"} />
                    نام نویسنده
                  </div>
                  <div className="calender">
                    <IconClander className={"icon-details"} />
                    تاریخ انتشار
                  </div>
                </div>
                <div className="time">
                  زمان مورد نیاز برای مطالعه : 5 دقیقه
                  <IconTime className={"icon-details"} />
                </div>
              </div>
            </header>
            <main>
              <div className="blogstitr">
                <BlogTitrComponentt
                  img={ImgBlog}
                  text={
                    "یارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگ ناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و،زاین دروم یژولونکت یلعفطیارشیراوشد و مامت هک تشاد دیما ناوت یم تروص نیا رد ،درک داجیا یسراف نابز رد ورشیپ گنهرف و ،یقالخناحارطصوصخلا یلع یا هنایار ناحارط یارب اریرتشیب تخانش اهرازفا مرن اب ات ،دبلط رارق هدافتسا دروم یحارط دوجوم یایندلها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب پیات تخسطیارش و،اهراکهار هئارا رد دوجوم.دریگیارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و ،زایندروم یژولونکت یلعف طیارشسا دروم یحارط دوجوم یایند لها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب "
                  }
                />
                <BlogTitrComponentt
                  title={"تیتر اول"}
                  img={ImgBlog}
                  text={
                    "یارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگ ناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و،زاین دروم یژولونکت یلعفطیارشیراوشد و مامت هک تشاد دیما ناوت یم تروص نیا رد ،درک داجیا یسراف نابز رد ورشیپ گنهرف و ،یقالخناحارطصوصخلا یلع یا هنایار ناحارط یارب اریرتشیب تخانش اهرازفا مرن اب ات ،دبلط رارق هدافتسا دروم یحارط دوجوم یایندلها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب پیات تخسطیارش و،اهراکهار هئارا رد دوجوم.دریگیارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و ،زایندروم یژولونکت یلعف طیارشسا دروم یحارط دوجوم یایند لها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب "
                  }
                />
              </div>
              <div className="nav-footer-blogstitr">
                <div className="source"> منبع:.... </div>
                <div className="left-e">
                  <div className="footer-icon">
                    <Link to="/">
                      52
                      <IconComment />
                    </Link>
                    <Link to="/">
                      54
                      <IconLike />
                    </Link>
                  </div>
                  <div className="footer-icon-sochial">
                    اشتراک گذاری:
                    <div className="icon-sochial-blogs">
                      <IconTwitter style={{ marginLeft: "24px" }} />
                      <IconInstagram style={{ marginLeft: "24px" }} />
                      <IconLinkdin />
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
          <aside className="sidebar">ehsanz</aside>

          <div className="responsive-component-cms">
            <div className="border-x" />
            <BlogTags text={"برچسب ها :"} tag={"کلمه مربوط"} />
            <div className="border-x " />
            <BlogInputComment />
            <div className="comments">
              <p className="comments-title-blog"> دیدگاه های نوشته شده </p>
              <BlogComment />
              <BlogComment />
              <BlogComment />
            </div>
            <div className="footer-content-blogs">
              <BlogComponents
                className={"blogs-home"}
                style={{ width: "45%" }}
                title={"عنوان متن"}
                text={
                  "لورم ایپسوم متن ساختگی  با تولید سادگی نامفهوم از صنعت چاپ و با با تولید سادگی نامفهوم از صنعت چاپ و با می باشد"
                }
              />
              <BlogComponents
                className={"blogs-home"}
                style={{ width: "45%" }}
                title={"عنوان متن"}
                text={
                  "لورم ایپسوم متن ساختگی  با تولید سادگی نامفهوم از صنعت چاپ و با با تولید سادگی نامفهوم از صنعت چاپ و با می باشد"
                }
              />
            </div>
          </div>
        </Styles>
      </MainLayout>
    );
  } else {
    return (
      <MainLayout {...props}>
        <Styles>
          <div className="container">
            <div className="content">
              <header className="header-container">
                <div className="border" />
                <div className="title-blog-det">
                  <p>عنوان مطلب</p>
                  <div className="icon">
                    <IconBookMark stroke={"#323130"} />
                    <div className="line" />
                    <IconLike />
                  </div>
                </div>
                <div className="details">
                  <div className="header-detail">
                    <div className="name">
                      <IconProfileBlog className={"icon-details"} />
                      نام نویسنده
                    </div>
                    <div className="calender">
                      <IconClander className={"icon-details"} />
                      تاریخ انتشار
                    </div>
                  </div>
                  <div className="footer-detail">
                    <IconTime className={"icon-details"} />
                    زمان مورد نیاز برای مطالعه : 5 دقیقه
                  </div>
                </div>
              </header>
              <main>
                <div className="blogstitr">
                  <BlogTitrComponentt
                    img={ImgBlog}
                    text={
                      "یارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگ ناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و،زاین دروم یژولونکت یلعفطیارشیراوشد و مامت هک تشاد دیما ناوت یم تروص نیا رد ،درک داجیا یسراف نابز رد ورشیپ گنهرف و ،یقالخناحارطصوصخلا یلع یا هنایار ناحارط یارب اریرتشیب تخانش اهرازفا مرن اب ات ،دبلط رارق هدافتسا دروم یحارط دوجوم یایندلها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب پیات تخسطیارش و،اهراکهار هئارا رد دوجوم.دریگیارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و ،زایندروم یژولونکت یلعف طیارشسا دروم یحارط دوجوم یایند لها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب "
                    }
                  />
                  <BlogTitrComponentt
                    title={"تیتر اول"}
                    img={ImgBlog}
                    text={
                      "یارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگ ناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و،زاین دروم یژولونکت یلعفطیارشیراوشد و مامت هک تشاد دیما ناوت یم تروص نیا رد ،درک داجیا یسراف نابز رد ورشیپ گنهرف و ،یقالخناحارطصوصخلا یلع یا هنایار ناحارط یارب اریرتشیب تخانش اهرازفا مرن اب ات ،دبلط رارق هدافتسا دروم یحارط دوجوم یایندلها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب پیات تخسطیارش و،اهراکهار هئارا رد دوجوم.دریگیارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و ،زایندروم یژولونکت یلعف طیارشسا دروم یحارط دوجوم یایند لها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب "
                    }
                  />
                  <BlogTitrComponentt
                    title={"تیتر اول"}
                    img={ImgBlog}
                    text={
                      "یارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگ ناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و،زاین دروم یژولونکت یلعفطیارشیراوشد و مامت هک تشاد دیما ناوت یم تروص نیا رد ،درک داجیا یسراف نابز رد ورشیپ گنهرف و ،یقالخناحارطصوصخلا یلع یا هنایار ناحارط یارب اریرتشیب تخانش اهرازفا مرن اب ات ،دبلط رارق هدافتسا دروم یحارط دوجوم یایندلها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب پیات تخسطیارش و،اهراکهار هئارا رد دوجوم.دریگیارب و ،تسا مزال هک نانچنآرطس و نوتس رد هلجم و همانزور هکلب نوتم و اهرگپاچ ،تسا کیفارگناحارط زا هدافتسا اب و ،پاچ تعنص زا موهفمان یگداس دیلوت اب یگتخاس نتم موسپیا مرولناصصختم و هعماج ناوارف تخانش ،هدنیآ و لاح هتشذگ دصرد هس و تصش رد یدایز یاهباتک ،دشاب یم یدربراک یاهرازبا دوبهب فده اب عونتم یاهدربراک و ،زایندروم یژولونکت یلعف طیارشسا دروم یحارط دوجوم یایند لها هتسویپ تالاوس یوگباوج و ،یلصا یاهدرواتسد ینیچفورح لماش زاین دروم نامز و دسر نایاپ هب "
                    }
                  />
                </div>
                <div className="source"> منبع:.... </div>
                <div className="footer-icon">
                  <div className="icon-cm-like">
                    <Link to="/">
                      5
                      <IconComment />
                    </Link>
                    <Link to="/">
                      10
                      <IconLike />
                    </Link>
                  </div>
                  <div className="sochial-in-blog">
                    <p>اشتراک گذاری:</p>
                    <IconTwitter /> <IconInstagram />
                    <IconLinkdin />
                  </div>
                </div>
                <div className="border-x" />
                <BlogTags text={"برچسب ها :"} tag={"کلمه مربوط"} />
                <div className="border-x" />
                <div className="border" />
                <BlogInputComment />
                <div className="border" />
                <div className="comments">
                  <p className="titelcomments"> دیدگاه های نوشته شده:</p>
                  <BlogComment />
                  <div className="border" />
                  <BlogComment />
                  <div className="border" />
                  <BlogComment />
                  <div className="border" />
                </div>
              </main>
            </div>
          </div>
          <div className="footer-content-blogs">
            <Blogs />
          </div>
        </Styles>
      </MainLayout>
    );
  }
};
